import { WebPortalService } from '../resource'

const AgentNumberModule = {
  namespaced: true,
  state: {
    data: [],
    dataImport: [],
  },
  mutations: {
    SET_DATA (state, data) {
      state.data = data
    },
    SET_DATA_IMPORT (state, data) {
      state.dataImport = data
    }
  },
  actions: {
    resetPassword({ commit, state }, data) {
        return WebPortalService.resetPasswordNumber(data)
    },
    comPortalLogin ({ commit, state }, data) {
        return WebPortalService.ComProtalLogin(data)
    },
    syncPackage ({ commit, state }, data) {
        return WebPortalService.SyncPackage(data)
    },
    createData ({ commit, state }, data) {
        return WebPortalService.NumberCreate(data)
    },
    updateData ({ commit, state }, data) {
        return WebPortalService.NumberUpdate(data)
    },
    deleteData ({ commit, state }, data) {
        return WebPortalService.NumberDelete(data)
    },
    importNumber ({ commit, state }, data) {
      return WebPortalService.NumberImport(data)
    },
    clearImportNumber ({ commit, state }, data) {
      return WebPortalService.ClearNumberImport(data)
    },
    async listData ({ commit, state }) {
      try{
        const data = await WebPortalService.NumberList()
        if (data.data.Data == null) 
        {
          commit('SET_DATA', [])
        }
        else 
        {
          commit('SET_DATA', data.data.Data)
        }
      }
      catch(err)
      {
        commit('SET_DATA', [])
      }
    },
    async listDataByEnterprise ({ commit, state },param) {
      try{
        const data = await WebPortalService.NumberListByEnterprise(param)
        if (data.data.Data == null) 
        {
          commit('SET_DATA', [])
        }
        else 
        {
          commit('SET_DATA', data.data.Data)
        }
      }
      catch(err)
      {
        commit('SET_DATA', [])
      }
    },
    async listDataImport ({ commit, state }) {
      try{
        const data = await WebPortalService.NumberImportList()
        if (data.data.Data == null) 
        {
          commit('SET_DATA_IMPORT', [])
        }
        else 
        {
          commit('SET_DATA_IMPORT', data.data.Data)
        }
      }
      catch(err)
      {
        commit('SET_DATA_IMPORT', [])
      }
    }
  },
  getters: {
    getData (state) {
      return state.data
    },
    getDataImport (state) {
      return state.dataImport
    }
  }
}

export default AgentNumberModule